<template>
<div>
  <b-navbar toggleable="md" type="dark" variant="success">
    <b-navbar-brand href="#">空蝉(テスト版)</b-navbar-brand>
    <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
    <b-collapse id="nav-collapse" is-nav v-model="showCollapse">
      <b-navbar-nav>
        <b-nav-item to="/records">記録一覧</b-nav-item>
        <b-nav-item to="/individualRecords">個人記録</b-nav-item>
        <b-nav-item to="/inquiry">要望・お問い合せ</b-nav-item>
        <b-nav-item to="/userManage">管理</b-nav-item>
        <!-- <b-nav-item-dropdown left>
          <template #button-content>
            <em>サンプルページ</em>
          </template>
          <b-dropdown-item to="/success">記録</b-dropdown-item>
          <b-dropdown-item to="/statistics">統計</b-dropdown-item>
          <b-dropdown-item to="/goal">目標</b-dropdown-item>
        </b-nav-item-dropdown> -->
        <b-nav-item></b-nav-item>
        <b-nav-item></b-nav-item>
      </b-navbar-nav>
      <!-- Right aligned nav items -->
      <b-navbar-nav class="ml-auto">
        <router-link :to="{ name: 'individualRecords',query:{userId:this.user.uid,userName:this.userName}}">
          <b-navbar-brand>{{this.userName}}</b-navbar-brand>
        </router-link>
        <b-nav-item @click="logout" to="/">ログアウト</b-nav-item>
      </b-navbar-nav>
    </b-collapse>

    <router-view />
  </b-navbar>
  <br>
</div>
</template>
<style>
</style>
<script>
import firebase from 'firebase/app'
import 'firebase/auth'
import router from '../router'

export default {
  name: 'header-menu',
  data() {
    return {
      user: firebase.auth().currentUser,
      linkString: "/individualRecords?userName=",
      userName: "",
      showCollapse: false,
    }
  },
  watch: {
    '$route'() {
      this.showCollapse = false
    }
  },
  created: function() {
    this.database = firebase.database();
    this.user = firebase.auth().currentUser;
    this.linkString = this.linkString + this.user.displayName + "&userId=" + this.user.uid;
    var _this = this
    firebase.database().ref('users/' + this.user.uid + '/name').once("value", snapShot => {
      if (snapShot) {
        _this.userName = snapShot.val();
        // 利用申請する前はGoogleアカウントの表示名を出す
        if (this.userName == null) {
          _this.userName = this.user.displayName
        }
      }
    })
  },
  methods: {
    logout() {
      firebase.auth().signOut().then(function() {
        router.push('/')
      }).catch(error => {
        console.log(error.message)
        router.push('/')
      })
    },
  },
}
</script>
